import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Dialog, Grid, Typography, DialogContent, DialogActions } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

import Button from '_components/button'
import IconButton from '_components/svg/icon-button'

import useStyles from './styles'

const WarningModal = ({ handleModal, title, children, className, contentClassName }) => {
  const styles = useStyles()

  return (
    <Dialog open onClose={handleModal} className={classnames(styles.modal, className)}>
      <Grid className={styles.header}>
        {title && (
          <Typography component="span" className={styles.title}>
            {title}
          </Typography>
        )}
        <Grid className={styles.buttons}>
          <IconButton
            aria-label="Close modal"
            onClick={handleModal}
            buttonClassName={styles.iconButton}
          >
            <CloseIcon className={styles.icon} />
          </IconButton>
        </Grid>
      </Grid>
      <DialogContent className={classnames(styles.content, contentClassName)}>
        {children}
      </DialogContent>
      <DialogActions className={styles.actions}>
        <Button className={styles.button} onClick={handleModal} color="primary" variant="contained">
          Entendi
        </Button>
      </DialogActions>
    </Dialog>
  )
}

WarningModal.propTypes = {
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  handleModal: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
}

WarningModal.defaultProps = {
  children: PropTypes.node,
  className: '',
  contentClassName: '',
  title: '',
}
export default React.memo(WarningModal)
